module.exports = __webpack_public_path__ + "img/ai_lifeboat.44b3bf48.jpg";